<template>
  <div class="workspace_wrap home_wrap">
    <msgDialog :visible.sync="msgdialog" v-if="msgdialog"></msgDialog>
    <div class="home_container">
      <!--概括-->
      <div class="home_generalization home_box_bg">
        <div class="home_title_name">
          <p class="home_title_name_p">数据概况
            <el-tooltip class="item" effect="light" placement="bottom-start">
              <div slot="content" class="infocontent">
                <p>累计线索：截止目前，访问过所选部门员工名片或者文章的所有独立用户（去重，已用户ID为判断标准）</p>
                <p>累计线索池：截止目前，存在于所选部门员工线索池（即除客户以外的）的所有独立用户数。</p>
                <p>累计客户：截止目前，访问过所选部门员工名片的所有独立用户（去重，已用户ID为判断标准）</p>
                <p>累计访问量：截止目前，访问过所选部门员工名片的所有独立用户</p>
                <p>累计跟进：截止目前，所选部门跟进的用户总数</p>
                <p>累计咨询：截止目前，向所选部门员工发起过咨询的用户总数</p>
                <p>转发量：所有名片被转发次数</p>
                <p>订单量：所有用户产生的订单量（周期时间内同一客户二次购买累加计算）</p>
              </div>
              <i class="iconfont iconbangzhu1"></i>
            </el-tooltip>
          </p>
          <div class="home_title_name_right">
            <el-radio-group v-model="tabPosition" @change="radioChangetabPosition" size="small" fill="rgba(41, 167, 244, 0.27)">
              <el-radio-button label="0">累计</el-radio-button>
              <el-radio-button label="1">昨天</el-radio-button>
              <el-radio-button label="2">近7天</el-radio-button>
              <el-radio-button label="3">近30天</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="home_generalization_body">
          <div class="home_generalization_body_list">
            <!--<i class="iconfont iconbangzhu"></i>-->
            <span class="home_generalization_body_list_span">累计线索</span>
            <p class="home_generalization_body_list_p">{{datasurvey.clues}}</p>
          </div>
          <div class="home_generalization_body_list">
            <span class="home_generalization_body_list_span">累计线索池</span>
            <p class="home_generalization_body_list_p">{{datasurvey.clues_pool}}</p>
          </div>
          <div class="home_generalization_body_list">
            <span class="home_generalization_body_list_span">累计访问量</span>
            <p class="home_generalization_body_list_p">{{datasurvey.traffic}}</p>
          </div>
          <div class="home_generalization_body_list">
            <span class="home_generalization_body_list_span">累计咨询</span>
            <p class="home_generalization_body_list_p">{{datasurvey.consult}}</p>
          </div>
          <div class="home_generalization_body_list">
            <span class="home_generalization_body_list_span">累计跟进</span>
            <p class="home_generalization_body_list_p">{{datasurvey.follow_up}}</p>
          </div>
          <div class="home_generalization_body_list">
            <span class="home_generalization_body_list_span">累计客户</span>
            <p class="home_generalization_body_list_p">{{datasurvey.customer}}</p>
          </div>
          <div class="home_generalization_body_list">
            <span class="home_generalization_body_list_span">名片被转发</span>
            <p class="home_generalization_body_list_p">{{datasurvey.shares}}</p>
          </div>
          <div class="home_generalization_body_list">
            <span class="home_generalization_body_list_span">名片被点赞</span>
            <p class="home_generalization_body_list_p">{{datasurvey.givelike}}</p>
          </div>
        </div>
      </div>
      <!--数据指标-->
      <div class="home_data_index home_box_bg">
        <div class="home_title_name">
          <p class="home_title_name_p">数据指标</p>
          <div class="home_data_index_tab">
            <span :class="line_chart_Tab==0?'home_data_index_tab_active':''" @click="chartTab(0)">订单量</span>
            <span :class="line_chart_Tab==1?'home_data_index_tab_active':''" @click="chartTab(1)">咨询量</span>
            <span :class="line_chart_Tab==2?'home_data_index_tab_active':''" @click="chartTab(2)">递名片</span>
            <span :class="line_chart_Tab==3?'home_data_index_tab_active':''" @click="chartTab(3)">被转发</span>
          </div>
          <div class="home_data_index_color">
            <p><span></span>订单量</p>
            <p><span></span>咨询量</p>
          </div>
          <div class="home_data_index_right">
            <el-radio-group v-model="tabData" @change="radioChangetabData" size="small" fill="rgba(41, 167, 244, 0.27)">
              <el-radio-button label="0">近7天</el-radio-button>
              <el-radio-button label="1">近30天</el-radio-button>
              <el-radio-button label="2">近6个月</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="home_data_index_body">
          <div class="echarts_index" id="echarts_index"></div>
        </div>
      </div>
      <!--销售概况-->
      <div class="home_sales_overview home_box_bg">
        <div class="home_title_name">
          <p class="home_title_name_p">销售概况</p>
        </div>
        <div class="home_sales_overview_body">
          <div class="home_sales_overview_body_list">
            <i class="indexIcon indexhome01"></i>
            <div class="home_sales_overview_body_list_line">
              <p class="home_sales_overview_body_list_line_title">商品销售金额</p>
              <p class="home_sales_overview_body_list_line_price">
                <span>￥</span>{{homeInfo?homeInfo.sale.goods_money:'--'}}
              </p>
              <p class="home_sales_overview_body_list_line_smallprice">
                +￥{{homeInfo?homeInfo.sale.goods_money_today:'--'}}
              </p>
            </div>
          </div>
          <div class="home_sales_overview_body_list">
            <i class="indexIcon indexhome02"></i>
            <div class="home_sales_overview_body_list_line">
              <p class="home_sales_overview_body_list_line_title">销售佣金金额</p>
              <p class="home_sales_overview_body_list_line_price">
                <span>￥</span>{{homeInfo?homeInfo.sale.commission_money:'--'}}
              </p>
              <p class="home_sales_overview_body_list_line_smallprice">
                +￥{{homeInfo?homeInfo.sale.commission_money_today:'--'}}
              </p>
            </div>
          </div>
          <div class="home_sales_overview_body_list">
            <i class="indexIcon indexhome03"></i>
            <div class="home_sales_overview_body_list_line">
              <p class="home_sales_overview_body_list_line_title">直销的销售额</p>
              <p class="home_sales_overview_body_list_line_price">
                <span>￥</span>{{homeInfo?homeInfo.sale.commission_direct:'--'}}
              </p>
              <p class="home_sales_overview_body_list_line_smallprice">
                +￥{{homeInfo?homeInfo.sale.commission_direct_today:'--'}}
              </p>
            </div>
          </div>
          <div class="home_sales_overview_body_list">
            <i class="indexIcon indexhome04"></i>
            <div class="home_sales_overview_body_list_line">
              <p class="home_sales_overview_body_list_line_title">分销的销售额</p>
              <p class="home_sales_overview_body_list_line_price">
                <span>￥</span>{{homeInfo?homeInfo.sale.commission_distribution:'--'}}
              </p>
              <p class="home_sales_overview_body_list_line_smallprice">
                +￥{{homeInfo?homeInfo.sale.commission_distribution_today:'--'}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--趋势图-->
      <div class="home_trend_map home_box_bg">
        <div class="home_trend_map_tab">
          <!--数据查看类型(0今天、1昨天、2最近7天、3最近30天)-->
          <span :class="trendChart==0?'home_trend_map_tab_active':''" @click="radioChangetrendChart(0)">
            今天
          </span>
          <span :class="trendChart==1?'home_trend_map_tab_active':''" @click="radioChangetrendChart(1)">
            昨天
          </span>
          <span :class="trendChart==2?'home_trend_map_tab_active':''" @click="radioChangetrendChart(2)">
            最近7天
          </span>
          <span :class="trendChart==3?'home_trend_map_tab_active':''" @click="radioChangetrendChart(3)">
            最近30天
          </span>
        </div>
        <div class="home_trend_map_body">
          <div class="home_title_name">
            <p class="home_title_name_p">趋势图</p>
          </div>
          <div class="home_trend_map_body">
            <div id="echarts_trend_map_one" class="home_user_activity_echarts"></div>
          </div>
        </div>
      </div>
      <!--Top-->
      <div class="home_top_distribution_ranking mb10">
        <div class="home_top_distribution_ranking-list">
          <div class="home_title_name">
            <p class="home_title_name_p">Top场景值</p>
            <div class="home_title_name_more">
              <span>查看更多></span>
            </div>
          </div>
          <div class="home_top_distribution_ranking-list-body">
            <div id="echarts_top_pie" class="home_top_echarts" style="height: 380px"></div>
          </div>
        </div>
        <div class="home_top_distribution_ranking-list">
          <div class="home_title_name">
            <p class="home_title_name_p">Top10二维码</p>
            <div class="home_title_name_more">
              <!--<span>查看更多></span>-->
            </div>
          </div>
          <div class="home_top_distribution_ranking-list-body">
            <div class="home_top_right_list">
              <div class="home_top_right_list_th home_top_right_list_list">
                <span>页面</span>
                <span>受访次数</span>
                <span>占比</span>
              </div>
              <div class="home_top_right_list_tr home_top_right_list_list"
                   v-for="(item,index) in 10" :key="index">
                <template v-if="homeQrlist && homeQrlist[index]">
                  <span>{{index+1}}.{{homeQrlist[index].qrcode}}</span>
                  <span>{{homeQrlist[index].number}}</span>
                  <span>{{homeQrlist[index].percent}}%</span>                  
                </template>   
                <template v-else>
                  <span>{{index+1}}.暂无</span>
                  <span>暂无</span>
                  <span>--</span>                       
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--群体分析-->
      <div class="home_whole_analysis home_box_bg">
        <div class="home_title_name">
          <p class="home_title_name_p">群体分析</p>
        </div>
        <div class="home_whole_analysis_body">
          <div class="home_whole_analysis_body_list">
            <div class="home_whole_analysis_body_list_line">
              <p>男士:{{homeInfo?homeInfo.sex_percent.male:'--'}}</p>
              <p>{{homeInfo?homeInfo.sex_percent.male_percent:'--'}}%</p>
            </div>
            <div class="home_whole_analysis_body_list_line">
              <p>女士:{{homeInfo?homeInfo.sex_percent.male:'--'}}</p>
              <p>{{homeInfo?homeInfo.sex_percent.female_percent:'--'}}%</p>
            </div>
          </div>
          <div class="home_whole_analysis_body_list">
            <div class="home_whole_analysis_body_list_line">
              <p>新用户:{{homeInfo?homeInfo.user_percent.new:'--'}}</p>
              <p>{{homeInfo?homeInfo.user_percent.new_percent:'--'}}%</p>
            </div>
            <div class="home_whole_analysis_body_list_line">
              <p>老用户:{{homeInfo?homeInfo.user_percent.old:'--'}}</p>
              <p>{{homeInfo?homeInfo.user_percent.old_percent:'--'}}%</p>
            </div>
          </div>
          <div class="home_whole_analysis_body_list">
            <div class="home_whole_analysis_body_list_line">
              <p>活跃用户:{{homeInfo?homeInfo.user_percent.active:'--'}}</p>
              <p>{{homeInfo?homeInfo.user_percent.active_percent:'--'}}%</p>
            </div>
            <div class="home_whole_analysis_body_list_line">
              <p>新增用户:{{homeInfo?homeInfo.user_percent.new:'--'}}</p>
              <p>{{homeInfo?homeInfo.user_percent.create_percent:'--'}}%</p>
            </div>
          </div>
        </div>
      </div>
      <!--留存分析-->
      <div class="home_retention_analysis home_box_bg">
        <div class="home_trend_map_tab">
          <!--数据查看类型(0昨天、1最近7天、2最近30天)-->
          <!--retainedAnalysisForm:{-->
          <!--data_type: 0, // 0新增留存、1活跃留存-->
          <!--type:0 // 0昨天、1最近7天、2最近30天-->
          <!--}-->
          <span :class="retainedAnalysisForm.type==0?'home_trend_map_tab_active':''" @click="retainedAnalysisFn(0)">
            昨天
          </span>
          <span :class="retainedAnalysisForm.type==1?'home_trend_map_tab_active':''" @click="retainedAnalysisFn(1)">
            最近7天
          </span>
          <span :class="retainedAnalysisForm.type==2?'home_trend_map_tab_active':''" @click="retainedAnalysisFn(2)">
            最近30天
          </span>
        </div>
        <div class="home_trend_map_body">
          <div class="home_title_name">
            <p class="home_title_name_p">留存分析</p>
            <div class="radio-group-box">
              <el-radio-group v-model="retainedAnalysisForm.data_type" @change="retainedAnalysisFn('radio')"
                              size="small" fill="rgba(41, 167, 244, 0.27)">
                <el-radio-button label="0">新增留存</el-radio-button>
                <el-radio-button label="1">活跃留存</el-radio-button>
              </el-radio-group>
            </div>
            <div class="date-picker-box">
              <el-date-picker
                      v-model="dataTimeAnalysis"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      size="small"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      :picker-options="pickerTimeAnalysis"
              ></el-date-picker>
            </div>
            <el-button icon="el-icon-search" size="small" @click="searchRetainedAnalysis"></el-button>
          </div>
          <div class="home_trend_map_body_line">
            <div id="echarts_trend_map" class="home_user_activity_echarts"></div>
          </div>
        </div>
      </div>
      <!--用户活跃度-->
      <div class="home_user_activity mb10">
        <div class="home_trend_map_tab">
          <span :class="retainedActiveForm.type==0?'home_trend_map_tab_active':''" @click="retainedActiveFn(0)">
            昨天
          </span>
          <span :class="retainedActiveForm.type==1?'home_trend_map_tab_active':''" @click="retainedActiveFn(1)">
            最近7天
          </span>
          <span :class="retainedActiveForm.type==2?'home_trend_map_tab_active':''" @click="retainedActiveFn(2)">
            最近30天
          </span>
        </div>
        <div class="home_user_activity_body">
          <div class="home_title_name">
            <p class="home_title_name_p">用户活跃度</p>
            <div class="date-picker-box">
              <el-date-picker
                      v-model="dataTime"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      size="small"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      :picker-options="pickerActive"
              ></el-date-picker>
            </div>
            <el-button icon="el-icon-search" size="small" @click="searchRetainedActive"></el-button>
          </div>
          <div class="home_user_activity_body">
            <div id="echarts_user_activity" class="home_user_activity_echarts"></div>
          </div>
        </div>
      </div>
      <!--Top分布排行-->
      <div class="home_top_distribution_ranking">
        <div class="home_top_distribution_ranking-list">
          <div class="home_title_name">
            <p class="home_title_name_p">Top10地域分布</p>
            <div class="home_title_name_more">
              <!--<span>查看更多></span>-->
            </div>
          </div>
          <div class="home_top_distribution_ranking-list-body">
            <div id="echarts_index_three" class="home_top_echarts"></div>
          </div>
        </div>
        <div class="home_top_distribution_ranking-list">
          <div class="home_title_name">
            <p class="home_title_name_p">手机型号排行</p>
            <div class="home_title_name_more">
              <!--<span>查看更多></span>-->
            </div>
          </div>
          <div class="home_top_distribution_ranking-list-body">
            <div class="home_top_right_list" v-if="homeInfo">
              <div class="home_top_right_list_th home_top_right_list_list">
                <span>手机型号</span>
                <span>人数</span>
                <span>占比</span>
              </div>
              <!--homeInfo.mobile_model-->
              <div class="home_top_right_list_tr home_top_right_list_list"
                   v-for="(item,index) in 10" :key="index">
                <template v-if="homeInfo.mobile_model && homeInfo.mobile_model[index]">
                  <span>{{index+1}}.{{homeInfo.mobile_model[index].model}}</span>
                  <span>{{homeInfo.mobile_model[index].number}}</span>
                  <span>{{homeInfo.mobile_model[index].percent}}%</span>
                </template>
                <template v-else>
                  <span>{{index+1}}.暂无</span>
                  <span>暂无</span>
                  <span>--%</span>                
                </template>   
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home_top_height"></div>
    </div>
    <div class="home_container_right">
      <div class="home_container_right_a mb10">
        <div class="home_container_right_a_top">
          <img :src="homeInfo?homeInfo.info.pic:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'" alt=""
               class="home_container_right_a_top_img">
          <div class="home_container_right_a_top_title">
            <p>{{homeInfo?homeInfo.info.name:'--'}}</p>
            <p>账号ID：{{homeInfo?homeInfo.info.id:'--'}}</p>
          </div>
        </div>
        <div class="home_container_right_a_bottm">
          <p><span>已开通/可开通名片数</span><span>{{homeInfo?homeInfo.info.create_number:'--'}}/{{homeInfo?homeInfo.info.card_num:'--'}}</span>
          </p>
          <p><span>已用天数</span><span>{{homeInfo?homeInfo.info.use_time:'--'}}</span></p>
          <p><span>有效期至</span><span>{{homeInfo?homeInfo.info.expire_time:'--'}}</span></p>
        </div>
      </div>
      <div class="home_container_right_b mb10">
        <h2 class="right_home_title">系统公告</h2>
        <div>
          <el-timeline :reverse="reverse">
            <el-timeline-item
                    v-for="(activity, index) in newInfo"
                    :key="index"
                    :timestamp="activity.timestamp"
                    class="timeline-list" @click.native="goToNewsDetail(activity.id)">
              <span v-if="activity.content=='查看更多'" @click.stop="newListCheck" class="morenewList">{{activity.content}}</span>
              <span v-else>{{activity.content}}</span>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div class="home_container_right_c">
        <h2 class="right_home_title">联系我们</h2>
        <div class="home_container_right_c_box">
          <p><span>客服热线</span><span>400-800-0907</span></p>
          <p class="editdesc"><span>意见反馈</span><i class="iconfont iconbianji" style="cursor: pointer" @click="goToFeedback"></i></p>
          <p>
            <span>关注造像时代公众号</span>
            <!--<img src="https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/zxgpc/images/20230826/9834ebdbc4cdc513fa3f4e7cd8f3e895.jpg" alt="">-->
            <el-popover
                    placement="left"
                    width="260"
                    trigger="hover">
              <img src="https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/zxgpc/images/20230826/9834ebdbc4cdc513fa3f4e7cd8f3e895.jpg" alt="" width="236" height="236">
              <img src="https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/zxgpc/images/20230826/9834ebdbc4cdc513fa3f4e7cd8f3e895.jpg" alt="" slot="reference">
            </el-popover>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import bottomlist from "@/components/menu.js";
  import {Notification} from "element-ui";
  import msgDialog from "./msgDialog.vue";
  import api from "@/api.js";
  import {yeartime, yearDatetime} from '@/assets/js/common'

  var echarts = require("echarts");
  export default {
    name: "workSpace",
    components: {
      msgDialog
    },
    name: "workspace",
    data() {
      return {
        msgdialog: false,
        dataTime: [],
        dataTimeAnalysis: [], // 留存时间
        reverse: false,
        options: [
          {
            value: 1,
            label: "线索总数"
          },
          {
            value: 2,
            label: "跟进总数"
          },
          {
            value: 3,
            label: "浏览总数"
          },
          {
            value: 4,
            label: "被转发总数"
          },
          {
            value: 5,
            label: "被保存总数"
          },
          {
            value: 6,
            label: "被点赞总数"
          }
        ],
        value: 1,
        trendChart: 0,// 数据查看类型(0今天、1昨天、2最近7天、3最近30天) 趋势图
        datachart: '0', // 数据查看类型(0本周、1近30天、2近六个月) 数据指标
        tabPosition: '0', //数据查看类型(0累计、1昨天、2近七天、3近30天) 数据概括
        tabData: '0',// 数据查看类型(0累计、1昨天、2近七天、3近30天)
        retainedAnalysisFlag: true,
        retainedActiveFlag: true,
        datasurvey: '',
        todayTime: yearDatetime(new Date()),
        bottomlist: bottomlist.homebottomlist || [],
        // 页面数据
        homeInfo: null,
        retainedAnalysisForm: {
          data_type: 0, // 0新增留存、1活跃留存
          type: 0, // 0昨天、1最近7天、2最近30天
          start_time: '',// start_time 	varchar 	必填 	- 	- 	开始时间
          end_time: ''// end_time 	varchar 	必填 	- 	- 	结束时间
        },
        retainedActiveForm: {
          data_type: 0, // 0新增留存、1活跃留存
          type: 0, // 0昨天、1最近7天、2最近30天
          start_time: '',// start_time 	varchar 	必填 	- 	- 	开始时间
          end_time: ''// end_time 	varchar 	必填 	- 	- 	结束时间
        },
        newInfo: [],
        pickerActive: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e7;
          }
        },
        pickerTimeAnalysis: {
          disabledDate(time) {
            return time.getTime() > Date.now() - 8.64e7;
          }
        },
        line_chart_Tab:0,
        bodywidth:0,
        homeQrlist: []
      };
    },
    created() {
      this.bodywidth = (document.body.clientWidth-240)+'px'
      Notification.closeAll();
      this.InitFn()
      this.survey()
      this.chart()
      this.trendChartFn()
      this.retainedAnalysisRespon()
      this.retainedActiveRespon()
      this.newFn()
      this.homeSence()
      this.homeQrStat()
    },
    mounted() {
      this.echarts();
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.home, {})
            .then(response => {
              if (response.data.code == 0) {
                this.homeInfo = response.data; 
                if (this.homeInfo.info.name) {
                  document.title = this.homeInfo.info.name
                }
                let addressName = [];
                let addressData = [];
                for (let i = 0; i < 10; ++i) {
                  if (response.data.regional[i]) {
                    if (response.data.regional[i].province) {
                      addressName.push(response.data.regional[i].province)
                    } else {
                      addressName.push('未知')
                    }
                    addressData.push(response.data.regional[i].number)
                  } else {
                    addressName.push('未知')
                    addressData.push(0)
                  }
                }
                this.echartsthree(addressName, addressData)

                // 是否弹窗提示到期
                let sDate1 = "2020-06-08"
                let date = new Date().toLocaleDateString().split("/")
                date.map(item => {
                  if (item < 9) {item = `0${item}`}
                })
                if (this.dateDiff(this.homeInfo.info.expire_time, date.join("-")) <= 30 ) {
                  this.$notify({
                    title: '温馨提示',
                    message: `你的企业将在${this.homeInfo.info.expire_time}到期，为避免功能停用造成的不便，请尽快联系运营商续费。（若无法联系到开户运营商，可拨打18876372189咨询）`,
                    duration: 0,
                    type: "warning",
                    customClass: "whd-red-warning"
                  })
                }
              } else {
              }
            })
            .catch(response => {
            });
      },
      dateDiff(sDate1, sDate2) { //sDate1和sDate2是2019-3-12格式
        var aDate, oDate1, oDate2, iDays
        aDate = sDate1.split("-")
        oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]) //转换为9-25-2017格式
        aDate = sDate2.split("-")
        oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
        iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数
        return iDays
      },
      // 数据概括
      survey() {
        // type 	varchar 	必填 	- 	- 	数据查看类型(0累计、1昨天、2近七天、3近30天)
        this.axios
            .post(api.home_survey, {type: this.tabPosition})
            .then(response => {
              if (response.data.code == 0) {
                this.datasurvey = response.data.info;
              } else {
              }
            })
            .catch(response => {
            });
      },

      chart() {
        // 数据查看类型(0本周、1近30天、2近六个月)
        this.axios
            .post(api.home_chart, {type: this.tabData})
            .then(response => {
              if (response.data.code == 0) {
                let dataTime = [];
                let order_ = [];
                let consult_ = [];
                for (let i in response.data.list) {
                  if (this.datachart === '1') {
                    dataTime.push(yeartime(response.data.list[i].date));
                  } else {
                    dataTime.push(response.data.list[i].day);
                  }
                  order_.push(response.data.list[i].order);
                  consult_.push(response.data.list[i].consult);
                }
                this.home_chart_data = response.data.list
                this.echarts()
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 趋势图
      trendChartFn() {
        //  	trendChart 数据查看类型(0今天、1昨天、2最近7天、3最近30天)
        this.axios
            .post(api.home_trend_chart, {type: this.trendChart})
            .then(response => {
              if (response.data.code == 0) {
                let TimeData = [];
                let listData = []
                for (let i in response.data.list) {
                  TimeData.push(response.data.list[i].day);
                  listData.push(response.data.list[i].new_user);
                }
                ;
                this.echartsTrendMap(TimeData, listData);
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 留存分析
      retainedAnalysisRespon() {
        // data_type 	varchar 	必填 	- 	- 	数据查看类型(0新增留存、1活跃留存)
        // type 	varchar 	必填 	- 	- 	数据查看类型(0昨天、1最近7天、2最近30天)
        // start_time 	varchar 	必填 	- 	- 	开始时间
        // end_time 	varchar 	必填 	- 	- 	结束时间
        this.axios
            .post(api.home_retained_analysis, this.retainedAnalysisForm)
            .then(response => {
              if (response.data.code == 0) {
                let time_ = [];
                let data_ = [];
                for (let i in response.data.list) {
                  // yeartime(response.data.list[i].date)
                  time_.push(response.data.list[i].day)
                  data_.push(response.data.list[i].percent)
                }
                this.trendMap(time_, data_)
                this.retainedAnalysisFlag = true
              } else {
              }
            })
            .catch(response => {
            });
      },
      retainedAnalysisFn(index) {
        if (this.retainedAnalysisFlag) {
          if (index !== 'radio') {
            this.retainedAnalysisForm.type = index;
          }
          ;
          this.retainedAnalysisFlag = false;
          this.retainedAnalysisRespon();
        }
      },
      // 留存时间
      searchRetainedAnalysis() {
        if (this.retainedAnalysisFlag) {
          this.retainedAnalysisFlag = false;
          if (this.dataTimeAnalysis) {
            if (this.dataTimeAnalysis.length !== 0) {
              this.retainedAnalysisForm.start_time = this.dataTimeAnalysis[0]
              this.retainedAnalysisForm.end_time = this.dataTimeAnalysis[1]
            }
          } else {
            this.retainedAnalysisForm.start_time = ''
            this.retainedAnalysisForm.end_time = ''
          }
          this.retainedAnalysisRespon();
        }
      },
      // top场景值
      homeSence() {
        // type 	varchar 	必填 	- 	- 	数据查看类型(0累计、1昨天、2近七天、3近30天)
        this.axios
            .post(api.home_sence, {})
            .then(response => {
              if (response.data.code == 0) {
                let sence_ = [];
                let number_ = [];
                for (let i in response.data.list) {

                }
                this.echartsPie()
              } else {
              }
            })
            .catch(response => {
            });
      },
      // Top二维码
      homeQrStat() {
        // type 	varchar 	必填 	- 	- 	数据查看类型(0累计、1昨天、2近七天、3近30天)
        this.axios
            .post(api.home_qr_stat, {})
            .then(response => {
              if (response.data.code == 0) {
                this.homeQrlist = response.data.list
              } else {
              }
            })
            .catch(response => {
            });
       },      
      // tab数据概括
      radioChangetabPosition() {
        this.survey()
      },
      // 数据指标
      chartTab(option){
        this.line_chart_Tab = option
        this.echarts()
      },
      radioChangetabData() {
        this.chart()
      },
      // 趋势图
      radioChangetrendChart(index) {
        this.trendChart = index
        this.trendChartFn()
      },
      // 用户活跃度
      retainedActiveRespon() {
        // data_type 	varchar 	必填 	- 	- 	数据查看类型(0新增留存、1活跃留存)
        // type 	varchar 	必填 	- 	- 	数据查看类型(0昨天、1最近7天、2最近30天)
        // start_time 	varchar 	必填 	- 	- 	开始时间
        // end_time 	varchar 	必填 	- 	- 	结束时间
        this.axios
            .post(api.home_user_activation, this.retainedActiveForm)
            .then(response => {
              if (response.data.code == 0) {
                let time_ = [];
                let data_ = [];
                for (let i in response.data.list) {
                  // yeartime(response.data.list[i].date)
                  time_.push(response.data.list[i].day)
                  data_.push(response.data.list[i].number)
                }
                this.activeUser(time_, data_)
                this.retainedActiveFlag = true
              } else {
              }
            })
            .catch(response => {
            });
      },
      retainedActiveFn(index) {
        if (this.retainedAnalysisFlag) {
          this.retainedActiveForm.type = index;
          this.retainedActiveFlag = false;
          this.retainedActiveRespon();
        }
      },
      searchRetainedActive() {
        if (this.retainedAnalysisFlag) {
          this.retainedAnalysisFlag = false;
          if (this.dataTimeAnalysis) {
            if (this.dataTimeAnalysis.length !== 0) {
              this.retainedAnalysisForm.start_time = this.dataTimeAnalysis[0]
              this.retainedAnalysisForm.end_time = this.dataTimeAnalysis[1]
            }
          } else {
            this.retainedAnalysisForm.start_time = ''
            this.retainedAnalysisForm.end_time = ''
          }
          this.retainedAnalysisRespon();
        }
      },
      echarts() {
        let obj_ = [{name:'订单量',val:'order'},{name:'咨询量',val:'consult'},{name:'递名片',val:'pass_card'},{name:'被转发',val:'shares'}]
        let dataList = []
        let TimeList = []
        // "order":"当时段订单量",
        //     "consult":"咨询量",
        //     "pass_card":"递名片",
        //     "shares":"被转发",
        for(let i in this.home_chart_data){
          TimeList.push(this.home_chart_data[i].day)
          dataList.push(this.home_chart_data[i][obj_[this.line_chart_Tab].val])
        }

        var myChart = echarts.init(document.getElementById("echarts_index"));
        let option = {
          tooltip: {
            trigger: "axis"
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: TimeList
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              name: obj_[this.line_chart_Tab].name,
              type: "line",
              itemStyle: {
                normal: {
                  color: '#5aa9f3',
                  lineStyle: {
                    color: '#5aa9f3'
                  }
                }
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#bbd9f6'
                  }])
                }
              },
              stack: "总量",
              data: dataList
            }
          ]
        };
        myChart.setOption(option);
      },
      echartsthree(name, data) {
        let myChart = echarts.init(document.getElementById("echarts_index_three"));
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          color: ['rgba(41, 167, 244, 0.27)'],
          xAxis: {
            type: 'category',
            data: name,
            axisLabel:{
              formatter:function(value){
                return value.split("").join("\n");
              }
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: data,
            type: 'bar'
          }]
        };
        myChart.setOption(option);
      },
      // 趋势图 echarts_trend_map
      echartsTrendMap(timedata, listData) {
        let myChart = echarts.init(document.getElementById("echarts_trend_map_one"));
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: timedata
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '趋势图',
              type: 'line',
              stack: '总量',
              itemStyle: {
                normal: {
                  color: 'rgba(41, 167, 244, 0.27)',
                  lineStyle: {
                    color: 'rgba(41, 167, 244, 0.27)'
                  }
                }
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#80e2a1'
                  }, {
                    offset: 1,
                    color: '#caf5cf'
                  }])
                }
              },
              smooth: true,
              data: listData
            }
          ]
        };
        myChart.setOption(option);
      },
      // top场景值
      echartsPie() {
        let myChart = echarts.init(document.getElementById("echarts_top_pie"));
        let option = {
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            y: 'bottom',
            data: ['微信聊天主界面下拉', '发现栏小程序主入口', '微信浮窗', '公众号自定义菜单', '安卓系统桌面图标', '其他'],
            icon: "circle"
          },
          series: [
            {
              name: '场景值',
              type: 'pie',
              radius: ['48%', '68%'],
              center: ['50%', '40%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: '12'
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: [
                {value: 335, name: '微信聊天主界面下拉'},
                {value: 310, name: '发现栏小程序主入口'},
                {value: 234, name: '微信浮窗'},
                {value: 135, name: '公众号自定义菜单'},
                {value: 1548, name: '安卓系统桌面图标'},
                {value: 250, name: '其他'}
              ],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
                normal: {
                  color: function (params) {
                    //自定义颜色
                    var colorList = [
                      '#58a7f2', '#73deb4', '#5a7099', '#ffb331', '#f88a89', '#84d1ef',
                    ];
                    return colorList[params.dataIndex]
                  }
                }
              }
            }
          ]
        };
        myChart.setOption(option);
      },
      // 留存分析
      trendMap(time, data) {
        let myChart = echarts.init(document.getElementById("echarts_trend_map"));
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: time
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '留存分析',
              type: 'line',
              stack: '总量',
              itemStyle: {
                normal: {
                  color: '#58a8f2',
                  lineStyle: {
                    color: '#58a8f2'
                  }
                }
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#8bc2f3'
                  }, {
                    offset: 1,
                    color: '#c4e2f9'
                  }])
                }
              },
              smooth: true,
              data: data
            }
          ]
        };
        myChart.setOption(option);
      },
      // 用户活跃度
      activeUser(time, data) {
        let myChart = echarts.init(document.getElementById("echarts_user_activity"));
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: time
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '用户活跃度',
              type: 'line',
              stack: '总量',
              itemStyle: {
                normal: {
                  color: '#1cc053',
                  lineStyle: {
                    color: '#1cc053'
                  }
                }
              },
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: '#9decb8'
                  }, {
                    offset: 1,
                    color: '#f0fbf4'
                  }])
                }
              },
              smooth: true,
              data: data
            }
          ]
        };
        myChart.setOption(option);
      },
      // 系统公告
      newFn() {
        this.axios
            .post(api.company_news, {})
            .then(response => {
              if (response.data.code == 0) {
                let list_ = [];
                for (let i in response.data.list) {
                  if (i <= 2) {
                    let list = {}
                    list.id = response.data.list[i].id;
                    list.content = response.data.list[i].title;
                    list.timestamp = response.data.list[i].keywords;
                    list_.push(list)
                  }
                }
                let list_last = {};
                if (list_.length >= 3) {
                  list_last = {
                    content: '查看更多',
                    timestamp: ''
                  };
                  list_.push(list_last);
                }
                this.newInfo = list_;
              } else {
              }
            })
            .catch(response => {
            });
      },
      newListCheck(){
        this.$router.push({name: "newsList"});
      },
      goToNewsDetail(id) {
        this.$router.push({name: "newsDetail", query: {id: id}});
      },
      goToFeedback() {
        this.$router.push({name: "feedbackList"});
      }
    }
  };
</script>
